import { useQuery } from '@apollo/client'
import { useContext, useMemo } from 'react'

import { GetCustomerVipDiscountDocument } from '../../../graphql/magento'
import { TokenContext } from '../../../layouts/context'

export type UseVipDiscountReturnType = (
  | {
      isEligibleForVipDiscount: false
      vipDiscountPercent: undefined
    }
  | {
      isEligibleForVipDiscount: true
      vipDiscountPercent: string
    }
) & {
  loading: boolean
}

export const useCustomerVipDiscount = (): UseVipDiscountReturnType => {
  const token = useContext(TokenContext)
  const { data, loading } = useQuery(GetCustomerVipDiscountDocument, {
    context: { token },
  })

  const vipDiscount = data?.customer?.vip_discount_name ?? undefined

  return useMemo(
    () =>
      vipDiscount && vipDiscount !== 'Ineligible'
        ? {
            isEligibleForVipDiscount: true,
            vipDiscountPercent: vipDiscount.replace(/\s*Discount\s*/, ''),
            loading,
          }
        : { isEligibleForVipDiscount: false, vipDiscountPercent: undefined, loading },
    [loading, vipDiscount],
  )
}
